import wretch from 'wretch';
var apiClient = /*#__PURE__*/wretch().options({
  credentials: 'same-origin'
});
export function getRequest(url, params) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$mountAt = _ref.mountAt,
      mountAt = _ref$mountAt === void 0 ? global.qtMountAt || "" : _ref$mountAt;

  var client = apiClient.url("".concat(mountAt).concat(url));
  if (params) client = client.query(params);
  return client.get();
}
export function postRequest(url, body) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$mountAt = _ref2.mountAt,
      mountAt = _ref2$mountAt === void 0 ? global.qtMountAt || "" : _ref2$mountAt;

  return apiClient.url("".concat(mountAt).concat(url)).post(body);
}